/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {BaseInstance} from './base-instance';
import {Dialog} from './dialog';
import {DialogData} from './dialog-data';
import {LocationInstance} from './location-instance';
import {ObjectInstance} from './object-instance';
import {Point} from './point';
import {TagInstance} from './tag-instance';
import {User} from './user';
import {ZoneInstance} from './zone-instance';

export class DialogInstance {
  id: number;
  dialog: Dialog;
  locationInstance: LocationInstance;
  zoneInstance: ZoneInstance;
  user: User;
  owner: User;
  tag: TagInstance;
  point: Point;
  status: Status;
  source: BaseInstance;
  message: string;
  comment: string;
  creationDate: Date;
  modifiedDate: Date;
  data: DialogData[];
  mapVips: ObjectInstance[];
}

export enum Status {
    OPEN = "OPEN",
    ACCEPTED = "ACCEPTED",
    CONFIRMED = "CONFIRMED",
    DECLINED = "DECLINED",
    CLOSED = "CLOSED"
}
